<template>
    <wire-frame-gdb>
        <template v-slot:top-main>
            <v-btn v-if="hasAnalitPerm.value" :to="{name: 'moodle-undb-analitico'}">Analítico</v-btn>
            <v-btn v-if="hasLogIntegPerm.value" :to="{name: 'moodle-undb-logs-integracoes', query: {instancia: 'Nível GRADUAÇÃO'}}">Log Integrações</v-btn>
            <v-btn v-if="hasResetPassPerm.value" :to="{name: 'moodle-undb-reset-password'}">Redefinição de Senha</v-btn>
            <v-btn v-if="hasLogResetPassPerm.value" :to="{name: 'moodle-undb-log-reset-password', query: {instancia: 'Classroom'}}">Logs de Redefinição de Senhas</v-btn>
            <v-divider class="my-2"></v-divider>
        </template>
    </wire-frame-gdb>
</template>
<script setup>
import { ref, computed } from 'vue';
import  { useRouter } from 'vue-router';
const hasAnalitPerm = ref(false)
const hasLogIntegPerm = ref(false)
const hasResetPassPerm = ref(false)
const hasLogResetPassPerm = ref(false)
const router = useRouter();
hasAnalitPerm.value = computed(() => router.resolve({name: 'moodle-undb-analitico'}).meta.has_perm())
hasLogIntegPerm.value = computed(() => router.resolve({name: 'moodle-undb-logs-integracoes'}).meta.has_perm())
hasResetPassPerm.value = computed(() => router.resolve({name: 'moodle-undb-reset-password'}).meta.has_perm())
hasLogResetPassPerm.value = computed(() => router.resolve({name: 'moodle-undb-log-reset-password'}).meta.has_perm())
</script>